exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Roboto&subset=cyrillic);", ""]);

// module
exports.push([module.id, "body,html{margin:0;padding:0;font-family:Roboto,sans-serif;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;color:#424242;display:flex;min-height:100vh;min-width:900px;justify-content:center}#app{width:100%;max-width:900px;margin:70px 50px}h1{font-weight:400}.text{line-height:1.5;color:#616161;margin-bottom:50px}.button:hover,button:hover{background-color:#66bb6a;box-shadow:0 3px 6px rgba(0,0,0,.16),0 3px 6px rgba(0,0,0,.23)}.button,button{color:#fff;border-radius:2px;background-color:#4caf50;border:none;cursor:pointer;text-decoration:none;padding:.8em 3em;line-height:1.8;vertical-align:bottom;text-align:center;box-shadow:0 1px 3px rgba(0,0,0,.12),0 1px 2px rgba(0,0,0,.24);transition:all .3s cubic-bezier(.25,.8,.25,1)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2eb5493b","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/App.vue
// module id = 22
// module chunks = 0